<template>
  <div class="body">
    <!-- 临时订单 -->
    <baseBreadcrumb :page="$t('message.temporaryOrder')" :menu="$t('message.orderForm')" />
    <div class="body">


      <div class="search">

        <!-- 开始日期-->
        <div class="item">
          <el-date-picker v-model="datas.created_at_start" :placeholder="$t('message.startDate')" type="datetime"
            default-time="['00:00:00']" value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </div>
        <!--  结束日期-->
        <div class="item">
          <el-date-picker v-model="datas.created_at_end" :placeholder="$t('message.dateClosed')"
            default-time="['23:59:59']" type="datetime" value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </div>
        <!--   /订单号-->
        <div class="item">
          <el-input v-model="datas.order_sn" :placeholder="$t('message.orderNumber')" class="Container"
            onfocus="this.select()" />
        </div>
        <!-- 客户ID-->
        <div class="item">
          <el-input v-model="datas.user_id" :placeholder="$t('message.clientID')" class="Container"
            onfocus="this.select()" />
        </div>
        <!--  状态 -->
        <!-- <div class="item">
            <el-select v-model="datas.status" :placeholder="$t('message.status')" filterable clearable placeholder="状态筛选">
              <el-option v-for="item in orderStatusList" :key="item.key" :label="item.value" :value="item.key">
              </el-option>
            </el-select>
          </div> -->
        <!--人员范围-->
        <div class="item">
          <!--  人员范围-->
          <cascader @setUserList="setUserList" :org_id="datas.org_id" ref="cascader" />
        </div>
        <div class="item">
          <!--  全体人员-->
          <el-select v-model="datas.admin_id" :placeholder="$t('message.specificPersonnel')" filterable clearable>
            <el-option v-for="item in userList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="item">
          <!--  搜索 -->
          <el-button type="primary" @click="search">{{
            $t("message.search")
            }}</el-button>
          <!--  重置 -->
          <el-button @click="reset">{{ $t("message.reset") }}</el-button>
        </div>
      </div>
      <div class="table">
        <el-table :data="tableData" :default-sort="{ prop: 'date', order: 'descending' }"
          :header-cell-style="{ background: '#EDEFF4' }" style="width: 100%" ref="multipleTable" size="mini" v-if="show"
          :max-height="tableautoheight">
          <el-table-column align="center" label="NO" prop="rowNumber" width="45">
          </el-table-column>
          <!--  订单提交时间-->
          <el-table-column align="center" :label="$t('message.orderSubmissionTime')" prop="created_at">
          </el-table-column>
          <!--  订单类别-->
          <el-table-column align="center" :label="$t('message.orderType')" width="80">
            <template slot-scope="scope">
              <!-- 国际阿里巴巴订单标识 -->
              <p v-if="scope.row.is_alibaba"><img src="@/assets/icon/alibaba.png" alt="" title="阿里巴巴国际站订单"></p>
              <span :class="{ isOEM: scope.row.type_name == 'OEM' }">
                {{ scope.row.type_name }}
              </span>

            </template>
          </el-table-column>
          <!-- 客户属性 -->
          <el-table-column align="center" :label="$t('message.customerProperty')">
            <template slot-scope="scope">
              <attributeName :name="scope.row.attribute_name" />
            </template>
          </el-table-column>
          <!--  订单号-->
          <el-table-column align="center" :label="$t('message.orderNumber')">
            <template slot-scope="scope">
              <p>
                <!-- 分批付款标记 -->
                <span v-if="scope.row.part_pay_status == 1" style="vertical-align: middle;"><img
                    src="@/assets/user/stages.png" alt=""></span>
                <!-- 手机下单标记 -->
                <span v-if="scope.row.from_tool != 1" style="vertical-align: middle;"><img
                    src="@/assets/icon/mobile.png" alt="" style="width: 25px;"></span>
                <router-link :to="'/orderDetail?order_sn=' + scope.row.order_sn" target="_blank">
                  {{ scope.row.order_sn }} </router-link>
                <span v-if="scope.row.modify_after_offer == 1" style="color:#b4272d">【改】</span>
              </p>
              <p>
                <router-link
                  :to="'/user/basicInformation?userID=' + scope.row.user.id + '&encryption=' + $md5(scope.row.user.id + '')"
                  target="_blank" style="color:#606266 ">
                  {{ scope.row.user.realname }}
                </router-link>
                <el-popover placement="top-start" trigger="hover" v-if="scope.row.children_user != null" title="子账号信息">
                  <p>{{ $t('message.names') }}:{{ scope.row.children_user.children_username }}</p>
                  <p>ID:{{ scope.row.children_user.id }}</p>
                  <img src="@/assets/user/children_user.png" alt="" slot="reference" style="vertical-align: middle;">
                </el-popover>
                <img src="@/assets/icon/illegal.png" alt="" slot="reference"
                  style="vertical-align: middle; width: 30px;" v-if="scope.row.user.user_tag != false">
              </p>
            </template>
          </el-table-column>
          <!--  操作人员-->
          <el-table-column align="center" :label="$t('message.operator')">
            <template slot-scope="scope">
              <div>
                <!-- 业务员 -->
                <p>
                  {{ $t("message.salesman") }}：{{ scope.row.y_admin ? scope.row.y_admin.realname : '' }}
                </p>
                <!-- 配货员 -->
                <p>
                  {{ $t("message.distributionMember") }}：{{ scope.row.p_admin ? scope.row.p_admin.realname : '' }}
                </p>
                <!-- 采购员 -->
                <p>{{ $t("message.buyer") }}：{{ scope.row.g_admin ? scope.row.g_admin.realname : '' }}</p>
              </div>
            </template>
          </el-table-column>
          <!--  订单番数-->
          <el-table-column align="center" :label="$t('message.ordersNumber')" width="80" prop="order_detail_count">
          </el-table-column>
          <!--  订单金额.元-->
          <el-table-column align="center" :label="$t('message.amountOfOrderYuan')"
            prop="total_amount_detail.total_amount">
          </el-table-column>
          <!--  报价状态-->
          <el-table-column align="center" :label="$t('message.quotationStatus')">
            <template slot-scope="scope">
              <p>
                <span> {{ scope.row.status_name }}</span>
              </p>
            </template>
          </el-table-column>
          <!--  业务订单备注-->
          <el-table-column align="center" :label="$t('message.serviceOrderRemarks')">
            <template slot-scope="scope">
              <el-input type="textarea" v-model="scope.row.y_remark" :disabled="remarkData.remark_type != 1"
                @blur="editRemark(scope.row.order_sn, scope.row.y_remark, remarkData.remark_type)"></el-input>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div class="paginationContainer">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
          :page-sizes="[10, 20, 50, 100]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["status"],
  data() {
    return {
      tableautoheight: window.innerHeight > 700 ? window.innerHeight - 160 : 800,
      datas: {
        order_sn: "",
        created_at_start: "",
        created_at_end: "",
        user_id: "",
        status: "10",
        org_id: "",
        work_group: "",
        admin_id: "",
        page: 1,
        pageSize: 100,
        noorderByAttribute: 1,
      },
      total: 0,
      tableData: [],
      show: false,
      remarkData: {
        order_sn: "",
        remark_type: localStorage.getItem("japanUserRoleStatus"), //工种
        remark: "",
      },
      userList: []
    };
  },
  created() {
    if (this.$route.query.user_id) {
      this.datas.user_id = this.$route.query.user_id
    }
    this.orderList();
  },
  methods: {
    orderList() {
      this.show = false;
      this.selectList = []
      this.$api.orderApi.orderList(this.datas).then((res) => {
        this.tableData = res.data.data;
        this.total = res.data.total;
        this.show = true;
      });
    },
    // 搜索订单
    search() {
      this.datas.page = 1;
      this.orderList();
    },
    // 重置
    reset() {
      this.datas = {
        order_sn: "",
        created_at_start: "",
        created_at_end: "",
        user_id: "",
        status: "10",
        org_id: "",
        work_group: "",
        admin_id: "",
        page: 1,
        pageSize: 10,
        y_id: '',
        p_id: '',
        g_id: '',
        noorderByAttribute: 1,
        attribute: '',
        type: ''
      };
      this.$refs.cascader.orgId = [];
      this.orderList();
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.orderList();
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.orderList();
    },
    // 实时编辑备注
    editRemark(order_sn, remark, remark_type,) {
      let datas = {
        order_sn,
        remark,
        remark_type,
      }
      this.$api.orderApi.updateRemark(datas).then((res) => {
        if (res.code != 0) return this.$message.error(res.message);
      });
    },
    // 人员范围
    setUserList(data) {
      this.userList = data.userList;
      this.datas.org_id = data.id;
      this.datas.admin_id = "";
    },
  },
};
</script>
<style lang='scss' scoped>
.search {
  display: flex;

  .item {
    margin-right: 20px;
    margin-bottom: 10px;
  }


}

.table {
  margin: 20px 0;
}








.textarea {
  padding: 0 20px;

  /deep/.el-textarea__inner {
    height: 100px;
  }
}

a {
  color: #b4272d;

  &:hover {
    text-decoration: underline;
  }
}

/deep/.has-gutter {
  height: 63px !important;
}
</style>